import { css } from 'styled-components';
import { media } from '../styles/constants';

export const padding = {
  smallPhone: {
    vertical: '8.5rem',
    horizontal: '2rem'
  },
  phone: {
    vertical: '8.5rem',
    horizontal: '3rem'
  },
  tabletPortrait: {
    vertical: '10.5rem',
    horizontal: '4rem'
  },
  tabletLandscape: {
    vertical: '10.5rem',
    horizontal: '4rem'
  },
  desktop: {
    vertical: '12.5rem',
    horizontal: '6rem'
  },
  bigDesktop: {
    vertical: '20rem',
    horizontal: '10rem'
  }
};

export const onlyHorizontalPaddingStyle = css`
  padding: 0 ${padding.smallPhone.horizontal};

  @media (min-width: ${media.phone}) {
    padding: 0 ${padding.phone.horizontal};
  }

  @media (min-width: ${media.tabletPortrait}) {
    padding: 0 ${padding.tabletPortrait.horizontal};
  }

  @media (min-width: ${media.tabletLandscape}) {
    padding: 0 ${padding.tabletLandscape.horizontal};
  }

  @media (min-width: ${media.desktop}) {
    padding: 0 ${padding.desktop.horizontal};
  }

  @media (min-width: ${media.bigDesktop}) {
    padding: 0 ${padding.bigDesktop.horizontal};
  }
`;

export const onlyVerticalPaddingStyle = css`
  padding: ${padding.smallPhone.vertical} 0 0 0;

  @media (min-width: ${media.phone}) {
    padding: ${padding.phone.vertical} 0 0 0;
  }

  @media (min-width: ${media.tabletPortrait}) {
    padding: ${padding.tabletLandscape.vertical} 0 0 0;
  }

  @media (min-width: ${media.tabletLandscape}) {
    padding: ${padding.tabletLandscape.vertical} 0 0 0;
  }

  @media (min-width: ${media.desktop}) {
    padding: ${padding.desktop.vertical} 0 0 0;
  }

  @media (min-width: ${media.bigDesktop}) {
    padding: ${padding.bigDesktop.vertical} 0 0 0;
  }
`;

export const paddingStyle = css`
  padding: ${padding.smallPhone.vertical} ${padding.smallPhone.horizontal} 0
    ${padding.smallPhone.horizontal};

  @media (min-width: ${media.phone}) {
    padding: ${padding.phone.vertical} ${padding.phone.horizontal} 0
      ${padding.phone.horizontal};
  }

  @media (min-width: ${media.tabletPortrait}) {
    padding: ${padding.tabletPortrait.vertical}
      ${padding.tabletPortrait.horizontal} 0
      ${padding.tabletPortrait.horizontal};
  }

  @media (min-width: ${media.tabletLandscape}) {
    padding: ${padding.tabletLandscape.vertical}
      ${padding.tabletLandscape.horizontal} 0
      ${padding.tabletLandscape.horizontal};
  }

  @media (min-width: ${media.desktop}) {
    padding: ${padding.desktop.vertical} ${padding.desktop.horizontal} 0
      ${padding.desktop.horizontal};
  }

  @media (min-width: ${media.bigDesktop}) {
    padding: ${padding.bigDesktop.vertical} ${padding.bigDesktop.horizontal} 0
      ${padding.bigDesktop.horizontal};
  }
`;
